const SEARCH_RESULTS = 'global-search-results';
const SEARCH_INPUT = 'global-search-input';

export { SEARCH_RESULTS, SEARCH_INPUT };
